import get from 'lodash/get'

// Let's you find out if user comes as a lead from self-signup
export function isSelfSignup (user) {
  const createdBy = get(user, 'createdBy', '')
  return createdBy === 'user-signup-service'
}
